(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-ann-bar]').forEach(function (bar) {
      var key = 'citera:ann:' + bar.getAttribute('data-ann-key');
      try {
        if (localStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
      var close = bar.querySelector('[data-ann-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.hidden = true;
          try {
            localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const openBtn = document.querySelector('[data-zoom-open]');
    const dialog = document.querySelector('[data-lightbox]');
    if (!openBtn || !dialog || typeof dialog.showModal !== 'function') return;
    const lbImg = dialog.querySelector('[data-lightbox-img]');
    const main = document.getElementById('product-media-main');
    const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
    const urls = thumbs.length
      ? thumbs.map((t) => t.dataset.full)
      : [main ? main.currentSrc || main.src : ''];
    let idx = 0;
    const show = (i) => {
      idx = (i + urls.length) % urls.length;
      lbImg.src = urls[idx];
    };
    const activeIndex = () => {
      const a = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      return a >= 0 ? a : 0;
    };
    openBtn.addEventListener('click', () => {
      show(activeIndex());
      dialog.showModal();
    });
    dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => show(idx - 1));
    dialog.querySelector('[data-lightbox-next]')?.addEventListener('click', () => show(idx + 1));
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-slideshow]').forEach((root) => {
    const track = root.querySelector('[data-slideshow-track]');
    const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
    if (!track || slides.length < 2) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;

    const go = (i, smooth = true) => {
      current = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: smooth && !reduce ? 'smooth' : 'auto',
      });
    };

    root.querySelector('[data-slideshow-next]')?.addEventListener('click', () => go(current + 1));
    root.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => go(current - 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    // Sync dots with the visible slide
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            current = slides.indexOf(e.target);
            dots.forEach((d, i) =>
              d.setAttribute('aria-selected', i === current ? 'true' : 'false'),
            );
          }
        });
      },
      { root: track, threshold: 0.6 },
    );
    slides.forEach((s) => io.observe(s));

    // Autoplay (disabled for reduced motion; pauses on hover/focus)
    if (root.dataset.autoplay === 'true' && !reduce) {
      const speed = Math.max(2, parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
      let timer = setInterval(() => go(current + 1), speed);
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        if (!timer) timer = setInterval(() => go(current + 1), speed);
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
